import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('properties-interests', storeModule.createStoreModule('properties-interests'))
